<template>
  <div class="datetime">
    <slot/>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
@import '~style/variables';

.datetime {
  color: $c-text-light;
  font-size: $h6;
  font-weight: $semibold;
}
</style>



// WEBPACK FOOTER //
// src/views/components/globals/DateTime.vue